import { Link } from 'react-router-dom';
import { EmptyState } from '../components/EmptyState.js';
import { Icon } from '../components/Icon.js';
import { labels } from '../labels.js';

export function NotFoundPage() {
  return (
    <main className="client-screen" style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', padding: 'var(--space-6)' }}>
      <EmptyState icon="info" title="404" text={labels.errors.notFound}>
        <Link to="/" className="btn-primary btn-lg">
          <Icon name="arrow-left" size={20} />
          {labels.scan.back}
        </Link>
      </EmptyState>
    </main>
  );
}
